module.exports = __webpack_public_path__ + "0fa82e336439e08d3af171bd3474c741.pdf";